(() => {
  if (window.__dtxCartShippingDateBound) return;
  window.__dtxCartShippingDateBound = true;

  const STYLE_ID = 'dtx-hide-dingdoong-notices';

  const injectHideStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      [id^="ot-dingdoong-root"] .ot-dingdoong-required-message,
      [id^="ot-dingdoong-root"] .ot-dingdoong-required-message > div,
      [id^="ot-dingdoong-root"] .ot-dingdoong-additional-message,
      [id^="ot-dingdoong-root"] .ot-dingdoong-header-additional-message,
      [id^="ot-dingdoong-root"] .dd-text-body-requiredMessage,
      [id^="ot-dingdoong-root"] .dd-custom-message,
      #dingdoong-embedded-render-root .ot-dingdoong-required-message,
      #dingdoong-embedded-render-root .ot-dingdoong-required-message > div,
      #dingdoong-embedded-render-root .ot-dingdoong-additional-message,
      #dingdoong-embedded-render-root .ot-dingdoong-header-additional-message,
      .cart-page__more-blocks .ot-dingdoong-required-message,
      .cart-page__more-blocks .ot-dingdoong-required-message > div,
      [data-dtx-dingdoong-modal] .ot-dingdoong-required-message,
      [data-dtx-dingdoong-modal] .ot-dingdoong-additional-message,
      [data-dtx-dingdoong-modal] .ot-dingdoong-header-additional-message,
      [data-dtx-dingdoong-modal] .dd-text-body-requiredMessage,
      [data-dtx-dingdoong-modal] .dd-custom-message {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
        pointer-events: none !important;
        opacity: 0 !important;
      }
    `;
    document.head.appendChild(style);
  };

  // Popup modal owns checkout gating — no MutationObserver / sync loops in the cart.
  injectHideStyles();
})();
